import React from 'react'
import { Box,Text,Img,} from '@chakra-ui/react'
import { motion } from 'framer-motion'
export const Header = () => {
  

  return (
    <>
    <Box name='About' display={'flex'} flexDirection={{xs:'column',sm: 'column', xl: 'row'}} maxW={{xs:'280px',sm: '300px', xl: '1366px'}} textAlign={'center'}  alignItems='center' justifyContent={'space-between'} margin='6rem auto'>
        <Img width={'20rem'} src='/assets/User-new.png'/>
        <Box width={{sm:'300px',lg:'500px', xl: '500px'}} margin='0rem 5rem'>
    <motion.div initial={{ opacity: 0 }}
  whileInView={{ opacity: 1,transition:{duration: 1}}}>
        <Text fontSize={{sm:'1.3rem',md: '1.5rem',ls:'1.5rem',lg: '1.7rem', xl: '2rem', '2xl': '2.5rem'}}>
            <Text as={'h2'} fontSize={'4rem'} fontWeight='900' color={'#000'}>Hola!</Text>
    Mi nombre es <Text display={'inline'} fontWeight={'900'} color='#000'>Lara Flores</Text> y soy <Text display={'inline'} fontWeight={'900'} color='#000'>Community Mánager.</Text></Text>
      </motion.div>
        </Box>
    </Box>
    <Box margin={'auto'}>
      <motion.div  animate={{y: '10px'}} transition={{repeat: Infinity,
    repeatType: "reverse",
    duration: 2}} >
        <Img width={'1.5rem'} src='/assets/X - 1.png'/>
      </motion.div>
    </Box>
    </>

  )
}
